module.exports = __webpack_public_path__ + "img/2F.b2d02866.png";